import { FETCH_PRICE_LISTS, FETCH_PRICE_LISTS_DETAIL, COMPARE_PRICE_LISTS, FETCH_PRICES_LIST_ERRORS, FETCH_PRICES } from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  priceListsList: {
    priceLists: [],
    hasMore: false,
    error: null,
    loading: true,
  },
  priceListDetail: {
    priceList: undefined,
    error: null,
    loading: true,
  },
  priceListPrices: {
    prices: undefined,
    error: null,
    hasMore: false,
    loading: true,
  },
  priceListErrors: {
    errors: undefined,
    error: null,
    hasMore: false,
    loading: true,
  },
  priceListsComparison: {
    comparison: undefined,
    error: null,
    loading: true,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_PRICE_LISTS
    // --------------------------------------------------------------------------
    case FETCH_PRICE_LISTS.init:
      return {
        ...state,
        priceListsList: { ...state.priceListsList, hasMore: false, error: null, loading: true },
      };
    case FETCH_PRICE_LISTS.success:
      return {
        ...state,
        priceListsList: {
          ...state.priceListsList,
          priceLists: action.payload.results,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_PRICE_LISTS.failure:
      return {
        ...state,
        priceListsList: {
          ...state.priceListsList,
          priceLists: [],
          pages: 1,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_PRICE_LISTS_DETAIL
    // --------------------------------------------------------------------------
    case FETCH_PRICE_LISTS_DETAIL.init:
      return {
        ...state,
        priceListDetail: { ...state.priceListDetail, error: null, loading: true },
      };
    case FETCH_PRICE_LISTS_DETAIL.success:
      return {
        ...state,
        priceListDetail: {
          ...state.priceListDetail,
          priceList: action.payload,
          error: null,
          loading: false,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
        },
      };
    case FETCH_PRICE_LISTS_DETAIL.failure:
      return {
        ...state,
        priceListDetail: {
          ...state.priceListDetail,
          priceList: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_PRICES
    // --------------------------------------------------------------------------
    case FETCH_PRICES.init:
      return {
        ...state,
        priceListPrices: { ...state.priceListPrices, error: null, loading: true },
      };
    case FETCH_PRICES.success:
      return {
        ...state,
        priceListPrices: {
          ...state.priceListPrices,
          prices: action.payload.results,
          error: null,
          loading: false,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
        },
      };
    case FETCH_PRICES.failure:
      return {
        ...state,
        priceListPrices: {
          ...state.priceListPrices,
          prices: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_PRICES_LIST_ERRORS
    // --------------------------------------------------------------------------
    case FETCH_PRICES_LIST_ERRORS.init:
      return {
        ...state,
        priceListErrors: { ...state.priceListErrors, error: null, loading: true },
      };
    case FETCH_PRICES_LIST_ERRORS.success:
      return {
        ...state,
        priceListErrors: {
          ...state.priceListErrors,
          errors: action.payload.results,
          error: null,
          loading: false,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
        },
      };
    case FETCH_PRICES_LIST_ERRORS.failure:
      return {
        ...state,
        priceListErrors: {
          ...state.priceListErrors,
          errors: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // COMPARE_PRICE_LISTS
    // --------------------------------------------------------------------------
    case COMPARE_PRICE_LISTS.init:
      return {
        ...state,
        priceListsComparison: { ...state.priceListsComparison, error: null, loading: true },
      };
    case COMPARE_PRICE_LISTS.success:
      return {
        ...state,
        priceListsComparison: {
          ...state.priceListsComparison,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          comparison: action.payload,
          error: null,
          loading: false,
        },
      };
    case COMPARE_PRICE_LISTS.failure:
      return {
        ...state,
        priceListsComparison: {
          ...state.priceListsComparison,
          comparison: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
